
// dictionary names inspired by http://chir.ag/projects/ntc/ntc.js

export const COLORS = {
  "000000": "Black",
  "000080": "Navy Blue",
  "0000C8": "Dark Blue",
  "0000FF": "Blue",
  "003366": "Midnight Blue",
  "003532": "Deep Teal",
  "008080": "Teal",
  "009DC4": "Pacific Blue",
  "00CC99": "Caribbean Green",
  "00FF00": "Green",
  "00FF7F": "Spring Green",
  "010D1A": "Blue Charcoal",
  "01361C": "Cardin Green",
  "01371A": "County Green",
  "013E62": "Astronaut Blue",
  "013F6A": "Regal Blue",
  "016D39": "Fun Green",
  "01796F": "Pine Green",
  "017987": "Blue Lagoon",
  "01A368": "Green Haze",
  "02402C": "Sherwood Green",
  "02478E": "Congress Blue",
  "026395": "Bahama Blue",
  "032B52": "Green Vogue",
  "041322": "Black Pearl",
  "042E4C": "Blue Whale",
  "044259": "Teal Blue",
  "051657": "Gulf Blue",
  "055989": "Venice Blue",
  "08E8DE": "Bright Turquoise",
  "09230F": "Palm Green",
  "09255D": "Madison",
  "093624": "Bottle Green",
  "095859": "Deep Sea Green",
  "0C8990": "Blue Chill",
  "0D0332": "Black Rock",
  "13264D": "Blue Zodiac",
  "1450AA": "Tory Blue",
  "161D10": "Hunter Green",
  "16322C": "Timber Green",
  "163531": "Gable Green",
  "175579": "Chathams Blue",
  "182D09": "Deep Forest Green",
  "193751": "Nile Blue",
  "1959A8": "Fun Blue",
  "1C1E13": "Rangoon Green",
  "1C39BB": "Persian Blue",
  "1D6142": "Green Pea",
  "1E433C": "Te Papa Green",
  "20208D": "Jacksons Purple",
  "220878": "Deep Blue",
  "228B22": "Forest Green",
  "240A40": "Violet",
  "242E16": "Black Olive",
  "251607": "Graphite",
  "251706": "Cannon Black",
  "290C5E": "Violent Violet",
  "29AB87": "Jungle Green",
  "2A380B": "Turtle Green",
  "2A52BE": "Cerulean Blue",
  "2B0202": "Sepia Black",
  "2C0E8C": "Blue Gem",
  "2E8B57": "Sea Green",
  "301F1E": "Cocoa Brown",
  "370202": "Chocolate",
  "3C4151": "Bright Gray",
  "3F5D53": "Mineral Green",
  "4169E1": "Royal Blue",
  "41AA78": "Ocean Green",
  "436A0D": "Green Leaf",
  "45B1E8": "Picton Blue",
  "480404": "Rustic Red",
  "483131": "Woody Brown",
  "495400": "Verdun Green",
  "4F7942": "Fern Green",
  "516E3D": "Chalet Green",
  "56B4BE": "Fountain Blue",
  "593737": "Congo Brown",
  "5D1E0F": "Redwood",
  "5F5F6E": "Mid Gray",
  "5F6672": "Shuttle Gray",
  "61845F": "Glade Green",
  "6456B7": "Blue Violet",
  "6495ED": "Cornflower Blue",
  "65000B": "Rosewood",
  "651A14": "Cherrywood",
  "660099": "Purple",
  "66023C": "Tyrian Purple",
  "66FF00": "Bright Green",
  "676662": "Ironside Gray",
  "678975": "Viridian Green",
  "6B3FA0": "Royal Purple",
  "6CDAE7": "Turquoise Blue",
  "71D9E2": "Aquamarine Blue",
  "72010F": "Venetian Red",
  "76D7EA": "Sky Blue",
  "77DD77": "Pastel Green",
  "78866B": "Camouflage Green",
  "7A58C1": "Fuchsia Blue",
  "800000": "Maroon",
  "80341F": "Red Robin",
  "803790": "Vivid Violet",
  "8AB9F1": "Jordy Blue",
  "8B8680": "Natural Gray",
  "8D8974": "Granite Green",
  "8DA8CC": "Polo Blue",
  "9370DB": "Medium Purple",
  "964B00": "Brown",
  "967059": "Leather",
  "967BB6": "Lavender Purple",
  "991199": "Violet Eggplant",
  "A69279": "Donkey Brown",
  "A9A491": "Gray Olive",
  "A9ACB6": "Aluminium",
  "A9B2C3": "Cadet Blue",
  "ACB78E": "Swamp Green",
  "ADFF2F": "Green Yellow",
  "AE4560": "Hippie Pink",
  "AF593E": "Brown Rust",
  "B10000": "Bright Red",
  "B5B35C": "Olive Green",
  "B6B095": "Heathered Gray",
  "B81104": "Milano Red",
  "B8C1B1": "Green Spring",
  "BB3385": "Medium Red Violet",
  "BDB1A8": "Silk",
  "C154C1": "Fuchsia Pink",
  "C5E17A": "Yellow Green",
  "C62D42": "Brick Red",
  "C71585": "Red Violet",
  "C9B93B": "Earls Green",
  "C9C0BB": "Silver Rust",
  "C9FFE5": "Aero Blue",
  "CBCAB6": "Foggy Gray",
  "E2F3EC": "Apple Green",
  "E8EBE0": "Green White",
  "ED9121": "Carrot Orange",
  "F5F5DC": "Beige",
  "FEFCED": "Orange White",
  "FF0000": "Red",
  "FF3F34": "Red Orange",
  "FF681F": "Orange",
  "FFAE42": "Yellow Orange",
  "FFBF00": "Amber",
  "FFC0CB": "Pink",
  "FFD700": "Gold",
  "FFEFD5": "Papaya Whip",
  "FFEFEC": "Fair Pink",
  "FFF0DB": "Peach Cream",
  "FFF6F5": "Rose White",
  "FFF8D1": "Baja White",
  "FFFDD0": "Cream",
  "FFFF00": "Yellow",
  "FFFFFF": "White"
};
